<template>
  <div>
    <a-form-item
      v-for="(k, index) in urls"
      :key="index"
      v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
      :label="index === 0 ? varLabel : ''"
      :required="false"
    >
      <a-input
        :size="size"
        v-decorator="[
          `${varName}[${index}]`,
          {
            validateTrigger: ['change', 'blur'],
            rules: [
              {
                required: true,
                whitespace: false,
                message: 'Please input a valid URI.',
                type: 'string',
                pattern: new RegExp(/^(?:([a-z0-9+.-]+:\/\/)((?:(?:[a-z0-9-._~!$&'()*+,;=:]|%[0-9A-F]{2})*)@)?((?:[a-z0-9-._~!$&'()*+,;=]|%[0-9A-F]{2})*)(:(?:\d*))?(\/(?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*)?|([a-z0-9+.-]+:)(\/?(?:[a-z0-9-._~!$&'()*+,;=:@]|%[0-9A-F]{2})+(?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*)?)(\?(?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*)?(#(?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*)?$/i)
                /* Logic from https://snipplr.com/view/6889/regular-expressions-for-uri-validationparsing */
              },
            ], initialValue: k
          },
        ]"
        placeholder="Valid URL"
        style="width: 90%; margin-right: 8px"
      >
        <a-icon slot="addonAfter" type="link" />
      </a-input>
      <a-icon
        v-if="urls.length > 1"
        class="dynamic-delete-button"
        type="minus-circle-o"
        :disabled="urls.length === 1"
        @click="() => remove(index)"
      />
    </a-form-item>
    <a-form-item v-bind="formItemLayoutWithOutLabel">
      <a-button type="dashed" style="width: 60%" @click="add">
        <a-icon type="plus" />Add
      </a-button>
      <a-alert type="info" showIcon style="margin-top:5px;" v-if="description">
        <p v-html="description" slot="message"></p>
      </a-alert>
    </a-form-item>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urls: [],
      formItemLayout: {
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          }
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 14
          }
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 14,
            offset: 5
          }
        }
      }
    };
  },
  props: {
    varName: String,
    varLabel: String,
    varInitial: Array,
    form: Object,
    size: String,
    description: [String, null]
  },

  created() {
    Object.assign(this.urls, this.varInitial);
  },

  methods: {
    remove(k) {
      this.urls.splice(k, 1);
    },

    add() {
      this.urls.push("com.mydomain.app://");
    }
  }
};
</script>

<style>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
